import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import StarRating from './starrating';
import { HOSTS } from './../../lib/helper';

const StatCard = ({ number, label }) => (
  <div className="stat-card">
    <div className="stat-number">{number}</div>
    <div className="stat-label">{label}</div>
  </div>
);

const MgCompleted = ({ migrate, canUpsell, task }) => {
  const reviewLink = "https://wordpress.org/support/plugin/migrate-guru/reviews/#new-post";
  const planPrice = 299;
  const discount = 40;

  return (
    <div className="mg-completed-container">
      <div className="migration-status-section">
        <h1 className="success-title">Migration Completed Successfully!</h1>

        <div className="migration-flow">
          <div className="source-site">
            <span className="site-url">{migrate.get('source_site')}</span>
          </div>

          <div className="migration-arrow">
            <i className="mdi mdi-arrow-right-thick"></i>
          </div>

          <div className="destination-site">
            <span className="site-url">{migrate.get('destination_site')}</span>
          </div>

          <div className="visit-site">
            <a href={migrate.get('destination_site')} 
               className="visit-site-button">
              <i className="mdi mdi-open-in-new"></i> Visit Site
            </a>
            {migrate.get('destination_host') === HOSTS.PANTHEON && (
              <a href={migrate.get('migration_completed_link')} 
                 className="dashboard-button">
                <i className="mdi mdi-view-dashboard"></i> Dashboard
              </a>
            )}
          </div>
        </div>
      </div>

			{canUpsell && <React.Fragment>
				<div className="mg-review-section">
					<div className="review-content">
						<span className="review-title">
							Love MigrateGuru? <span className="heart">❤️</span>
						</span>
						<div className="review-actions">
							<a href={reviewLink} 
								className="review-button"
								target="_blank"
								rel="noopener noreferrer">
								<StarRating percentRating={100} />
							</a>
							<a href={reviewLink}
								className="review-button"
								target="_blank"
								rel="noopener noreferrer">
								Rate Us
							</a>
							<a href="https://wordpress.org/support/plugin/migrate-guru"
								className="help-button"
								target="_blank"
								rel="noopener noreferrer">
								Need Help?
							</a>
						</div>
					</div>
				</div>

				<div className="mg-security-promotion">
					<div className="brand-header">
						<img 
							src="/assets/malcare-black-cropped.png"
							alt="MalCare Security Suite"
							className="malcare-logo"
						/>
						<div className="brand-trust">
							Trusted by 200,000+ websites across 120 Countries
						</div>
					</div>

					<div className="urgency-message">
						<div className="urgency-content">
							<i className="mdi mdi-clock-alert"></i>
							<div className="urgency-text">
								<strong>Post-migration is crucial for security!</strong>
								<p>Secure your newly migrated site now.</p>
							</div>
						</div>
						<a 
							href="https://www.malcare.com/pricing/?utm_source=migrate_guru&utm_medium=post_migration&utm_campaign=security_urgent&ref=mg_completion&loc=40OFFMG"
							className="urgency-cta"
							target="_blank"
							rel="noopener noreferrer"
							>
							Secure My Site<i className="mdi mdi-arrow-right"></i>
						</a>
					</div>

					<div className="offer-banner">
						<div className="offer-tag">SPECIAL POST-MIGRATION OFFER</div>
						<div className="price-comparison">
							<span className="original-price">${planPrice}</span>
							<span className="arrow">→</span>
							<span className="discounted-price">${(planPrice - (planPrice * discount / 100)).toFixed(2)}</span>
						</div>
						<div className="savings-tag">Save {discount}% Today!</div>
					</div>

					<div className="trust-indicators">
						<div className="trust-item">
							<i className="mdi mdi-star"></i>
							<span>4.6/5 on Trustpilot</span>
						</div>
						<div className="trust-item">
							<i className="mdi mdi-shield-check"></i>
							<span>2 Billion+ Attacks Blocked Last Month</span>
						</div>
						<div className="trust-item">
							<i className="mdi mdi-lock"></i>
							<span>200,000+ Sites Protected</span>
						</div>
					</div>

					<div className="stats-grid">
						<StatCard number="18B+" label="Requests Processed" />
						<StatCard number="1,500+" label="Sites Cleaned" />
						<StatCard number="350K+" label="Bots Blocked" />
						<StatCard number="2B+" label="Attacks Blocked" />
					</div>

					<div className="features-section">
						<h3>Comprehensive Security Features</h3>
						<div className="features-grid">
							<div className="feature-item">
								<i className="mdi mdi-folder"></i>
								<span>Deep File & Database Malware Detection</span>
							</div>
							<div className="feature-item">
								<i className="mdi mdi-speedometer"></i>
								<span>Zero-Impact Server Performance</span>
							</div>
							<div className="feature-item">
								<i className="mdi mdi-lock"></i>
								<span>Advanced Zero-Day Attack Protection</span>
							</div>
							<div className="feature-item">
								<i className="mdi mdi-robot"></i>
								<span>Real-Time Bot & Traffic Control</span>
							</div>
							<div className="feature-item">
								<i className="mdi mdi-delete"></i>
								<span>One-Click Malware Removal</span>
							</div>
							<div className="feature-item">
								<i className="mdi mdi-shield"></i>
								<span>Brute-Force Attack Prevention</span>
							</div>
						</div>
					</div>
					<a 
						href="https://www.malcare.com/pricing/?utm_source=migrate_guru&utm_medium=post_migration&utm_campaign=security_offer&ref=mg_completion&loc=40OFFMG"
						className="secure-button"
						target="_blank"
						rel="noopener noreferrer"
						>
						Secure Your Site - {discount}% OFF <i className="mdi mdi-arrow-right"></i>
					</a>
				</div>
			</React.Fragment>}

      <style>{`
        .mg-completed-container {
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
        }

        .migration-status-section {
          background: #f8f9fa;
          padding: 25px;
          border-radius: 12px;
          margin-bottom: 30px;
          box-shadow: 0 2px 4px rgba(0,0,0,0.05);
        }

        .success-title {
          font-size: 24px;
          color: #2c3338;
          margin: 0 0 20px 0;
          text-align: center;
        }

        .migration-flow {
          display: flex;
          align-items: center;
          gap: 15px;
          flex-wrap: nowrap;
          background: white;
          padding: 15px;
          border-radius: 8px;
        }

        .source-site, .destination-site {
          flex: 1;
          min-width: 0;
        }

        .site-url {
          display: block;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #1a202c;
          font-size: 15px;
        }

        .migration-arrow {
          color: #48BB78;
          flex-shrink: 0;
          font-size: 20px;
          padding: 0 10px;
        }

        .visit-site {
          flex-shrink: 0;
          display: flex;
          gap: 10px;
        }

        .visit-site-button, .dashboard-button {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 16px;
          border-radius: 6px;
          text-decoration: none;
          color: white;
          font-size: 14px;
          transition: all 0.3s ease;
        }

        .visit-site-button {
          background: #4CAF50;
        }

        .dashboard-button {
          background: #3498db;
        }

        .visit-site-button:hover, .dashboard-button:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        .mg-review-section {
          margin-top: 30px;
          padding: 15px 20px;
          background: #f8f9fa;
          border-radius: 8px;
        }

        .review-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
        }

        .review-title {
          font-size: 16px;
          color: #2d3748;
          white-space: nowrap;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .heart {
          color: #ff6b6b;
        }

        .review-actions {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .review-button, .help-button {
          padding: 6px 12px;
          border: 1px solid #cbd5e0;
          border-radius: 6px;
          text-decoration: none;
          color: #4a5568;
          font-size: 14px;
          transition: all 0.3s ease;
          background: white;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .review-button:hover, .help-button:hover {
          background: #f7fafc;
          border-color: #a0aec0;
          transform: translateY(-1px);
        }

        .mg-security-promotion {
          background: #fff;
          border: 2px solid #ff6b6b;
          border-radius: 16px;
          padding: 30px;
          margin: 40px 0;
        }

        .brand-header {
          text-align: center;
          margin-bottom: 25px;
        }

        .malcare-logo {
          max-width: 200px;
          height: auto;
          margin-bottom: 15px;
        }

        .brand-trust {
          color: #4a5568;
          font-size: 16px;
          font-weight: 500;
        }

        .urgency-message {
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 20px;
          background: #fff5f5;
          padding: 20px;
          border-radius: 12px;
          margin: 30px 0;
        }

        .urgency-content {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .urgency-content i {
          font-size: 24px;
          color: #ff6b6b;
          flex-shrink: 0;
        }

        .urgency-text {
          color: #2d3748;
        }

        .urgency-text p {
          margin: 5px 0 0;
          color: #4a5568;
        }

        .urgency-cta {
          background: #ff6b6b;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          font-weight: 600;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 8px;
          transition: all 0.3s ease;
          white-space: nowrap;
        }

        .urgency-cta:hover {
          background: #ff5252;
          transform: translateY(-1px);
          box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);
        }

        .offer-banner {
          background: linear-gradient(135deg, #2d3748 0%, #1a202c 100%);
          color: white;
          padding: 20px;
          border-radius: 12px;
          text-align: center;
          margin-bottom: 30px;
        }

        .offer-tag {
          font-size: 18px;
          font-weight: 600;
          color: #48BB78;
        }

        .price-comparison {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 15px;
          margin: 15px 0;
        }

        .original-price {
          text-decoration: line-through;
          opacity: 0.7;
          font-size: 24px;
        }

        .arrow {
          color: #48BB78;
          font-size: 24px;
        }

        .discounted-price {
          font-size: 32px;
          font-weight: bold;
          color: #48BB78;
        }

        .savings-tag {
          background: #48BB78;
          display: inline-block;
          padding: 5px 15px;
          border-radius: 20px;
          font-size: 14px;
          font-weight: 600;
        }

        .trust-indicators {
          display: flex;
          justify-content: space-around;
          flex-wrap: wrap;
          gap: 20px;
          margin: 30px 0;
        }

        .trust-item {
          display: flex;
          align-items: center;
          gap: 10px;
          color: #4a5568;
          font-weight: 500;
        }

        .trust-item i {
          color: #48BB78;
          font-size: 20px;
        }

        .stats-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
          gap: 20px;
          margin: 30px 0;
        }

        .stat-card {
          background: #f7fafc;
          padding: 20px;
          border-radius: 12px;
          text-align: center;
          transition: transform 0.3s ease;
        }

        .stat-card:hover {
          transform: translateY(-5px);
        }

        .stat-number {
          font-size: 24px;
          font-weight: bold;
          color: #2d3748;
          margin-bottom: 5px;
        }

        .stat-label {
          color: #4a5568;
          font-size: 14px;
        }

        .features-section {
          margin: 30px 0;
        }

        .features-section h3 {
          text-align: center;
          color: #2d3748;
          margin-bottom: 20px;
        }

        .features-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 15px;
        }

        .feature-item {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 12px;
          background: #f7fafc;
          border-radius: 8px;
          transition: all 0.3s ease;
        }

        .feature-item:hover {
          background: #edf2f7;
          transform: translateX(5px);
        }

        .feature-item i {
          color: #48BB78;
          font-size: 20px;
        }

        .secure-button {
          background: #ff6b6b;
          color: white;
          padding: 15px 30px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: bold;
          font-size: 16px;
          width: 100%;
          max-width: 400px;
          margin: 20px auto 0;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          transition: all 0.3s ease;
        }

        .secure-button:hover {
          background: #ff5252;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(255, 107, 107, 0.2);
        }

        @media (max-width: 768px) {
          .mg-completed-container {
            padding: 15px;
          }

          .migration-flow {
            flex-direction: column;
            align-items: stretch;
            gap: 10px;
          }

          .migration-arrow {
            transform: rotate(90deg);
            text-align: center;
            padding: 5px 0;
          }

          .visit-site {
            flex-direction: column;
            width: 100%;
          }

          .visit-site-button,
          .dashboard-button {
            justify-content: center;
          }

          .site-url {
            text-align: center;
          }

          .review-content {
            flex-direction: column;
            gap: 15px;
            text-align: center;
          }

          .review-title {
            justify-content: center;
          }

          .review-actions {
            flex-wrap: wrap;
            justify-content: center;
          }

          .price-comparison {
            flex-direction: column;
            gap: 5px;
          }

          .trust-indicators {
            flex-direction: column;
          }

          .stats-grid {
            grid-template-columns: repeat(2, 1fr);
          }

          .features-grid {
            grid-template-columns: 1fr;
          }

          .urgency-message {
            flex-direction: column;
            text-align: center;
          }

          .urgency-content {
            flex-direction: column;
          }

          .urgency-cta {
            width: 100%;
            justify-content: center;
          }
        }
      `}</style>
    </div>
  );
};

MgCompleted.propTypes = {
  migrate: ImmutablePropTypes.map,
  canUpsell: PropTypes.bool,
  task: ImmutablePropTypes.map
};

export default MgCompleted;
